// The account-manager name shown on the account form and detail page. PURE.
// A manager whose access was turned off keeps their name ("Jo Smith (disabled)")
// instead of reading as "(unknown user: <uid>)", which looked like a broken link.

import { formatUserDisplayName } from './formatUserDisplayName';

interface ManagerUser {
  uid: string;
  email: string;
  displayName: string | null;
  disabledAt?: string | null;
}

export function accountManagerLabel(uid: string, users: readonly ManagerUser[]): string {
  const user = users.find((u) => u.uid === uid);
  if (!user) return `(unknown user: ${uid})`;
  const name = formatUserDisplayName(user as never, { full: true });
  return user.disabledAt ? `${name} (disabled)` : name;
}
